package com.exura.features.demosets.domain.usecase

import com.exura.features.demosets.domain.DemoSetsConstants
import com.exura.features.demosets.domain.model.PublishDemoSetRequest
import com.exura.features.demosets.domain.model.PublishDemoSetResponse
import dev.gitlive.firebase.functions.FirebaseFunctions

class PublishPlanDefinitionUseCase(
    private val functions: FirebaseFunctions,
) {

    suspend operator fun invoke(
        planDefinitionId: String,
        targetDemoId: String = "test-demo-set",
        isPrivate: Boolean = false,
    ): Result<String> = runCatching {

        val publishCallable = functions.httpsCallable(DemoSetsConstants.Functions.PUBLISH_DEMO_SET)

        val request = PublishDemoSetRequest(
            targetDemoId = targetDemoId,
            isPrivate = isPrivate,
            planDefinitionId = planDefinitionId,
        )
        println(request)

        val result = publishCallable(request)
        println(result.data<String>())
        val response = result.data<PublishDemoSetResponse>()


        if (response.success) {
            response.newPlanDefinitionId ?: "Published successfully"
        } else {
            throw Exception(response.message ?: "Failed to publish plan")
        }
    }
}
